import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { LanguageServiceService } from './language-service.service';

@Injectable({
  providedIn: 'root'
})
export class i18Service {

  private readonly STORAGE_KEY = 'language';
  private readonly AVAILABLE_LANGS = ['en', 'ar', 'fr'];

  constructor(private transloco: TranslocoService,
    private languageService: LanguageServiceService,
  ) { }

  init() {
    this.transloco.setAvailableLangs(this.AVAILABLE_LANGS);
    this.transloco.setDefaultLang('en');

    const savedLang = localStorage.getItem(this.STORAGE_KEY);
    const browserLang = navigator.language.split('-')[0];

    const lang =
      savedLang ||
      (this.AVAILABLE_LANGS.includes(browserLang) ? browserLang : 'en');

    this.setLanguage(lang);
  }

  setLanguage(lang: string) {
    const nextLang = this.AVAILABLE_LANGS.includes(lang) ? lang : 'en';

    this.transloco.setActiveLang(nextLang);
    localStorage.setItem(this.STORAGE_KEY, nextLang);
    this.setDirection(nextLang);
    this.languageService.changeLanguage(nextLang);
  }

  toggleLanguage() {
    const current = this.transloco.getActiveLang();
    const currentIndex = this.AVAILABLE_LANGS.indexOf(current);
    const newLang = this.AVAILABLE_LANGS[(currentIndex + 1) % this.AVAILABLE_LANGS.length];
    this.setLanguage(newLang);
    window.location.reload();
  }

  private setDirection(lang: string) {
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }
}
